import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 2,
  class: "time-out-flag"
}
const _hoisted_3 = {
  key: 3,
  class: "new-list-flag"
}
const _hoisted_4 = {
  key: 4,
  class: "black-list-flag"
}
const _hoisted_5 = {
  key: 5,
  class: "black-list-flag"
}
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }

import { reactive, computed, onMounted, ref } from 'vue'
import { potentialList, potentialDetail } from '@/api/yuntuSales/customerCenter'
import {
  businessTypeEnum,
  clientsStatusEnum,
  customerTypeEnum,
  remanentFollowDayTypeEnum,
  customerUnfollowDayTypeEnum,
  tmsCustomerValueEnum, favoriteStatus,
  settlementTypeEnum
} from '@/views/yuntuSales/commonEnum/dataConfig'
import transferModel from '../components/transferModel.vue'
import { useRouter, useRoute } from 'vue-router'
import RelationCustomer from '@/components/RelationCustomer/index.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerMaps from '@/components/CustomerMaps/index.vue'
import CosMergeButton from '@/components/CosMergeButton'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ExportDetails from '@/views/gucangSales/clueManage/salesClue/components/ExportDetails.vue'
import SendLinkModel from '../components/sendLinkModel.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { addToFav, cancelToFav, listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
import type { PotentialItem } from '@/typings/api/customerCenter'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'
import ApplyCoupon from '../components/applyCoupon.vue'

const __default__ = { name: 'DcCosLbuClients' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()
const tableRef = ref()
const transferModelRef = ref()
const relationCustomerRef = ref()
const sendLinkModelRef = ref()
const customerMapsRef = ref()

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

const applyCouponRef = ref()
const handleApplyCoupon = () => {
  applyCouponRef.value.toggle(selectedRows.value)
}

const selectedRows = ref<PotentialItem[]>([])
const queryForm = reactive({
  sortCollection: 1,
  timeType: 1,
  contact: {
    type: 1
  },
  stage: 4 // 2 潜在 3签约 4成交
})
const paramCodeData = reactive<{
  lbu_customer_business_area: []
  lbu_sales_category: []
  lbu_cargo_type: []
  lbu_logistics_service_provider: []
  lbu_shipping_channel: []
  lbu_daily_traffic: []
  lbu_sale_platform: []
  lbu_demand_country: []
  lbu_erp_info: []
  lbu_loss_reason: []
  lbu_important: [],
  lbu_customer_grade: []
}>({
  lbu_customer_business_area: [],
  lbu_sales_category: [],
  lbu_cargo_type: [],
  lbu_logistics_service_provider: [],
  lbu_shipping_channel: [],
  lbu_daily_traffic: [],
  lbu_sale_platform: [],
  lbu_demand_country: [],
  lbu_erp_info: [],
  lbu_loss_reason: [],
  lbu_important: [],
  lbu_customer_grade: [],
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_customer_business_area',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_loss_reason',
      'lbu_important',
      'lbu_customer_grade'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const handledQueryParams = (params: any) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  if (queryForm.sortingFields !== undefined) {
    queryForm.sortCollection = undefined
  }
  return queryForm
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  const queryForm = handledQueryParams(params)
  potentialList({
    ...queryForm
  }).then((res) => {
    callBack(res)
  })
}
// 掩码信息
const showMask = (record: PotentialItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    callBack(res.data.contact)
  })
}
const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle(selectedRows.value)
}
// 发送注册链接
const handleSendLink = (row: PotentialItem) => {
  sendLinkModelRef.value.toggle(row)
}
const handleMap = (row: PotentialItem) => {
  customerMapsRef.value.toggle({
    addressRefId: row.cosId,
    addressRefName: row.customerName
  })
}
// 编辑
const handleEdit = (row: PotentialItem) => {
  router.push({
    path: '/lbu/clients/edit',
    query: {
      cosId: row.cosId
    }
  })
}
// 写跟进
const handleFollowUp = (row: PotentialItem) => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: {
      followRefId: row.cosId,
      returnPath: route.fullPath
    }
  })
}
// 关联客户
const handleRelationCustomer = (row: PotentialItem) => {
  relationCustomerRef.value.toggle(row)
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 收藏
const addFavorite = (row: PotentialItem, index:number) => {
  addToFav({
    appId: 'cos_lbu',
    cosId: row.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.cosId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: PotentialItem, index:number) => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: row.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}
const statusEnum = clientsStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: '客户标签', dataIndex: 'label' },
  {
    title: '业务类型',
    dataIndex: 'businessType',
    dicData: businessTypeEnum
  },
  { title: '主账号代码', dataIndex: 'customerNumber' },
  { title: '路区代码', dataIndex: 'roadAreaCode' },
  { title: 'ID', dataIndex: 'cosId', width: 200 },
  { title: '状态', dataIndex: 'status' },
  { title: '来源渠道', dataIndex: 'channel', width: 150 },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '结算模式', dataIndex: 'settlementType', dicData: settlementTypeEnum },
  { title: '渠道代码', dataIndex: 'tmsChannelCode' },
  { title: '前负责人', dataIndex: 'prevSellerName' },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '客户类型', dataIndex: 'type', dicData: customerTypeEnum },
  { title: '客户等级', dataIndex: 'grade', dicData: paramCodeData.lbu_customer_grade },
  { title: '剩余跟进天数', dataIndex: 'remanentFollowDays' },
  { title: '未跟进天数', dataIndex: 'unfollowDays' },
  { title: '客户合同地址', dataIndex: 'customerAddress' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '传真号', dataIndex: ['contact', 'fax'] },
  { title: '备注', dataIndex: 'remark' },
  // { title: '业务地区', dataIndex: ['business', 'businessArea'], dicData: paramCodeData.lbu_customer_business_area },
  { title: '年销售GMV（元）', dataIndex: ['business', 'annualSales'], type: 'money', width: 150, sorter: true },
  // { title: '销售品类', dataIndex: ['business', 'salesCategory'], dicData: paramCodeData.lbu_sales_category },
  // { title: '货物类型', dataIndex: ['business', 'cargoType'], dicData: paramCodeData.lbu_cargo_type },
  // {
  //   title: '现有合作物流服务商',
  //   dataIndex: ['business', 'cooperativeLogistics'],
  //   dicData: paramCodeData.lbu_logistics_service_provider,
  //   width: 150
  // },
  // { title: '出货渠道', dataIndex: ['business', 'deliveryChannel'], dicData: paramCodeData.lbu_shipping_channel },
  // {
  //   title: '客户日均包裹数量',
  //   dataIndex: ['business', 'dailyTraffic'],
  //   dicData: paramCodeData.lbu_daily_traffic,
  //   width: 150
  // },
  {
    title: '总TPR（元/月）',
    dataIndex: ['business', 'tpr'],
    type: 'money',
    sorter: true
  },
  {
    title: '总TPR（票数/月）',
    dataIndex: ['business', 'totalPotential'],
    type: 'money',
    sorter: true
  },
  { title: '首次领取时间', dataIndex: 'firstReceiveTime', width: 190, sorter: true },
  { title: '最后一次领取时间', dataIndex: 'lastReceiveTime', width: 190, sorter: true },
  { title: '转为成交时间', dataIndex: 'turnedTransaction', width: 190, sorter: true },
  { title: '流失原因', dataIndex: 'loseReason', dicData: paramCodeData.lbu_loss_reason },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  {
    title: '操作',
    dataIndex: 'action',
    width: 190,
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            rowKey: "cosId",
            "row-selection": { onChange: onSelectChange },
            serial: "",
            columns: columns.value,
            tableId: "lbuClients",
            onFetch: fetch,
            onMask: showMask,
            search: queryForm,
            "onUpdate:search": _cache[26] || (_cache[26] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: "客户名称",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "客户代码",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.tmsCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.tmsCode) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.status,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.status) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        mode: "multiple",
                        options: _unref(clientsStatusEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: queryForm.sellerList,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.sellerList) = $event)),
                        mode: "multiple"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "联系方式" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.contact.type,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.contact.type) = $event)),
                            style: {"width":"33%"},
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("手机号")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 3 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("邮箱")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 4 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("微信号")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 5 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("qq")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("固定电话")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_a_input, {
                            value: queryForm.contact.keyword,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                            maxlength: 500,
                            style: {"width":"67%"},
                            placeholder: "请输入"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: queryForm.customerRegionList,
                        "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.customerRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "员工区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: queryForm.employeeRegionList,
                        "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.employeeRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(ParamCodeCascader, {
                            type: "search",
                            ids: queryForm.channelList,
                            "onUpdate:ids": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.channelList) = $event)),
                            appId: "cos_lbu",
                            paramCode: "lbu_source_channel",
                            style: {"width":"33%"}
                          }, null, 8, ["ids"]),
                          _createVNode(_component_a_input, {
                            value: queryForm.channelExplain,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.channelExplain) = $event)),
                            maxlength: 100,
                            style: {"width":"67%"},
                            placeholder: "请输入"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "时间查询" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.timeType) = $event)),
                            style: {"width":"33%"},
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("创建时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("首次领取时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 3 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("最后一次领取时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 4 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("转为成交时间")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_cos_range_picker, {
                            style: {"width":"67%"},
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.endTime) = $event))
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "剩余跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.remanentFollowDayType,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.remanentFollowDayType) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(remanentFollowDayTypeEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosId,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.cosId) = $event)),
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "排序" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.sortCollection,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.sortCollection) = $event)),
                        options: _unref(favoriteStatus),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "未跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.unfollowDayType,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.unfollowDayType) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(customerUnfollowDayTypeEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户识别码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerSerial,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((queryForm.customerSerial) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主账号代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerNumber,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((queryForm.customerNumber) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "路区代码" }, {
                    default: _withCtx(() => [
                      _createVNode(RoadAreaSelect, {
                        permission: "",
                        value: queryForm.roadAreaUserList,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((queryForm.roadAreaUserList) = $event)),
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "渠道代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.tmsChannelCode,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((queryForm.tmsChannelCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户标签" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerLabelCascader, {
                        type: "search",
                        onlyCommon: false,
                        appId: "cos_lbu",
                        ids: queryForm.labelIdList,
                        "onUpdate:ids": _cache[21] || (_cache[21] = ($event: any) => ((queryForm.labelIdList) = $event)),
                        allowClear: ""
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "业务类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.businessTypeList,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((queryForm.businessTypeList) = $event)),
                        options: _unref(businessTypeEnum),
                        placeholder: "请选择",
                        mode: "multiple",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (handleTransfer()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("转移客户")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_clients_transfer_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(CosMergeButton), {
                data: selectedRows.value,
                appId: "cos_lbu",
                onSuccess: success
              }, {
                default: _withCtx(() => [
                  _createTextVNode("合并")
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_permission, 'lbu_clients_merge_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "304",
                search: handledQueryParams(queryForm)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_clients_export_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                onClick: _cache[24] || (_cache[24] = ($event: any) => (handleExportDetails()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出明细")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_clients_export_details_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                onClick: _cache[25] || (_cache[25] = ($event: any) => (handleApplyCoupon()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("发券申请")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_clients_apply_coupon_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text,index }) => [
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (record.collectionId===null)
                      ? (_openBlock(), _createBlock(FavoriteIcon, {
                          key: 0,
                          type: "add",
                          onClick: ($event: any) => (addFavorite(record,index))
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(FavoriteIcon, {
                          key: 1,
                          type: "cancel",
                          onClick: ($event: any) => (cancelFavorite(record,index))
                        }, null, 8, ["onClick"])),
                    (record.timeoutFlag === true)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "超时"))
                      : _createCommentVNode("", true),
                    (record.haveFollowFlag === false)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "New"))
                      : _createCommentVNode("", true),
                    (record.customerLabel && record.customerLabel.includes('L'))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "锁定"))
                      : _createCommentVNode("", true),
                    (record.customerLabel && record.customerLabel.includes('I'))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "作废"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: `/lbu/clients/view?cosId=${record.cosId}`,
                      class: "ant-table-cell-ellipsis",
                      title: text
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text || '--'), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "title"])
                  ]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'channel')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 1,
                    appId: "cos_lbu",
                    paramCode: "lbu_source_channel",
                    value: text,
                    desc: record.channelExplain
                  }, null, 8, ["value", "desc"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 2,
                    appId: "cos_lbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 3,
                    enums: _unref(statusEnum),
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'label')
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(record.label ? record.label.map((item) => item.labelName ).join('、') : '--'), 1))
                : _createCommentVNode("", true),
              (column.type === 'money')
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(formatThousandSeparator)(text)), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 6 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleFollowUp(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("写跟进")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_clients_follow_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_clients_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleRelationCustomer(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("关联客户")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_clients_relative_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleSendLink(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("发送注册链接")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_clients_send_link_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleMap(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("签到地址")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_clients_map_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["row-selection", "columns", "search"]),
          _createVNode(transferModel, {
            ref_key: "transferModelRef",
            ref: transferModelRef,
            onSuccess: success
          }, null, 512),
          _createVNode(RelationCustomer, {
            ref_key: "relationCustomerRef",
            ref: relationCustomerRef,
            onSuccess: success
          }, null, 512),
          _createVNode(SendLinkModel, {
            ref_key: "sendLinkModelRef",
            ref: sendLinkModelRef
          }, null, 512),
          _createVNode(CustomerMaps, {
            ref_key: "customerMapsRef",
            ref: customerMapsRef
          }, null, 512),
          _createVNode(ApplyCoupon, {
            ref_key: "applyCouponRef",
            ref: applyCouponRef,
            onSuccess: success
          }, null, 512),
          _createVNode(ExportDetails, {
            ref_key: "exportDetailsRef",
            ref: exportDetailsRef,
            appId: "cos_lbu",
            search: queryForm,
            taskTypeEnum: [
  { value: 313, label: '签到地址' },
  { value: 316, label: '在售平台' },
  { value: 319, label: '目的地国家' },
  { value: 322, label: '物流商' },
  { value: 325, label: '货物品类' },
  { value: 328, label: 'ERP系统' }
]
          }, null, 8, ["search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})